
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.98 10.2801L14.6 11.6601C14.4 11.8601 14.4 12.1701 14.6 12.3701L15.98 13.7501C16.26 14.0301 16.73 13.9001 16.83 13.5201C16.94 13.0201 17 12.5201 17 12.0001C17 11.4901 16.94 10.9901 16.82 10.5201C16.73 10.1401 16.26 10.0001 15.98 10.2801ZM20.1 7.78005C19.85 7.23005 19.12 7.11005 18.7 7.54005C18.44 7.80005 18.39 8.18005 18.53 8.52005C18.99 9.59005 19.25 10.7601 19.25 11.9901C19.25 13.2301 18.99 14.4101 18.52 15.4801C18.38 15.8001 18.43 16.1701 18.68 16.4201C19.09 16.8301 19.78 16.7101 20.03 16.1901C20.66 14.8901 21.01 13.4301 21.01 11.8901C21 10.4401 20.68 9.04005 20.1 7.78005ZM11.41 12.0001L15 8.42005C15.39 8.03005 15.39 7.40005 15 7.00005L10.71 2.71005C10.08 2.08005 8.99997 2.52005 8.99997 3.41005V9.59005L5.10997 5.70005C4.71997 5.31005 4.08997 5.31005 3.69997 5.70005C3.30997 6.09005 3.30997 6.72005 3.69997 7.11005L8.58997 12.0001L3.69997 16.8901C3.30997 17.2801 3.30997 17.9101 3.69997 18.3001C4.08997 18.6901 4.71997 18.6901 5.10997 18.3001L8.99997 14.4101V20.5901C8.99997 21.4801 10.08 21.93 10.71 21.3001L15 17.0001C15.39 16.6101 15.39 15.9801 15 15.5801L11.41 12.0001ZM11 5.83005L12.88 7.71005L11 9.59005V5.83005ZM11 18.1701V14.4101L12.88 16.2901L11 18.1701Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-bluetooth-searching`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconBluetoothSearching

    ```js
    <b-new-b-icon-bluetooth-searching />
    ```
</docs>


